import { type ReactNode, useMemo } from 'react';

import {
  CommandRegistrationContext,
  type CommandRegistrationContextValue,
  CommandRegistryContext,
  type CommandRegistryContextValue,
} from './command-registry-context';

/**
 * Inert registry contexts used by the ErrorBoundary fallback in
 * {@link import('./command-palette-provider').CommandPaletteProvider}.
 *
 * Lets consumer `useCommands` calls render without throwing when the
 * palette itself crashed. Registrations are silently dropped.
 */
export function DisabledCommandRegistryProvider({ children }: { children: ReactNode }) {
  const registrationValue = useMemo<CommandRegistrationContextValue>(
    () => ({
      setCommandsForSource: () => {},
      clearSource: () => {},
    }),
    [],
  );

  const registryValue = useMemo<CommandRegistryContextValue>(
    () => ({
      commands: {},
    }),
    [],
  );

  return (
    <CommandRegistrationContext.Provider value={registrationValue}>
      <CommandRegistryContext.Provider value={registryValue}>{children}</CommandRegistryContext.Provider>
    </CommandRegistrationContext.Provider>
  );
}
